import React, { useEffect, useState } from 'react'
import axios from '~/data/http/axios'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import i18n from '~/i18n'

export default function SubscriberSms({ id, subscriber }) {
    const [status, setStatus] = useState(null)
    const [loading, setLoading] = useState(true)

    const getStatus = async (id) => {
        setLoading(true)
        const result = await axios.get('/subscriber/' + id + '/sms')
        setStatus(result.data)
        setLoading(false)
    }

    const updateStatus = async (e) => {
        const status = e.currentTarget.value
        const update = {}
        if (status === 'active') {
            update.bounced = false
            update.unsubscribe = false
        } else if (status === 'bounced') {
            update.bounced = true
            update.unsubscribe = false
        } else if (status === 'unsubscribed') {
            update.bounced = false
            update.unsubscribe = true
        }
        await axios.put('/subscriber/' + id + '/sms', update)
        await getStatus(id)
    }

    useEffect(() => {
        getStatus(id)
    }, [id])

    if (!status) return <LoadingIcons iconType='2' />

    const phoneNumbers = subscriber.customFields.filter(
        (cf) => cf.fieldType === 'TELNO' && !!cf.value && cf.phoneNumber
    )

    const statuses = [
        { label: i18n.t('Active'), value: 'active' },
        { label: i18n.t('Bounced'), value: 'bounced' },
        { label: i18n.t('Unsubscribed'), value: 'unsubscribed' }
    ]

    let value = 'active'
    if (status.bounced) value = 'bounced'
    else if (status.unsubscribe) value = 'unsubscribed'

    return (
        <Paper className='mar-t20 mar-b0'>
            <h4 className='mar-b20'>{i18n.t('subscribers:subscriber.sms.header')}</h4>

            <div className='mar-b20 quickFlex'>
                <Select data={statuses} value={value} onChange={updateStatus} disabled={loading} />
            </div>

            <h4 className='mar-b20'>{i18n.t('subscribers:subscriber.sms.valid')}</h4>
            {phoneNumbers.map((cf) => {
                return (
                    <SquareChip key={cf.id} className='mar-r5'>
                        {cf.value}
                    </SquareChip>
                )
            })}
            {!phoneNumbers.length && <div>{i18n.t('subscribers:subscriber.sms.noValid')}</div>}
        </Paper>
    )
}
